import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Wrench, LogOut, User } from "lucide-react";

export default function Header({ variant = "public" }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const onHome = loc.pathname === "/";

  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-white/70 border-b border-neutral-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-14 sm:h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 group" data-testid="brand-logo">
          <div className="w-8 h-8 sm:w-9 sm:h-9 bg-neutral-900 text-white grid place-items-center rounded-lg group-hover:rotate-6 transition-transform">
            <Wrench size={16} />
          </div>
          <div className="leading-none">
            <div className="font-heading font-black text-base sm:text-lg tracking-tight">GTec</div>
            <div className="hidden sm:block text-[10px] uppercase tracking-[0.2em] text-neutral-500">Assistência técnica</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-6 text-sm font-medium">
          {onHome && <a href="#como-funciona" className="hover:text-neutral-900 text-neutral-600">Como funciona</a>}
          {onHome && <a href="#seguranca" className="hover:text-neutral-900 text-neutral-600">Segurança</a>}
          <Link to="/admin" className="text-neutral-600 hover:text-neutral-900" data-testid="nav-admin">Painel Admin</Link>
        </nav>

        <div className="flex items-center gap-1.5 sm:gap-2">
          {user ? (
            <>
              <Button variant="ghost" size="sm" onClick={() => nav(user.role === "admin" || user.role === "superadmin" ? "/admin" : "/minha-conta")} data-testid="nav-account">
                <User size={16} className="sm:mr-1.5" /><span className="hidden sm:inline">{user.name?.split(" ")[0]}</span>
              </Button>
              <Button variant="outline" size="sm" onClick={async () => { await logout(); nav("/"); }} data-testid="btn-logout">
                <LogOut size={14} />
              </Button>
            </>
          ) : (
            <>
              <Button variant="ghost" size="sm" onClick={() => nav("/login")} data-testid="nav-login">Entrar</Button>
              <Button size="sm" className="rounded-full bg-neutral-900 hover:bg-neutral-800 hidden sm:inline-flex" onClick={() => nav("/cadastro")} data-testid="nav-register">
                Criar conta
              </Button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
